.loading {
    position: absolute;
    inset: 0 0 auto;
    height: calc(
        100dvh - var(--overlappable-nav-height) - var(--top-nav-height)
    );
    pointer-events: none;
    z-index: 1;
    opacity: 1;
    transition: opacity var(--fade-duration) ease-out var(--fade-delay);
    display: flex;
    justify-content: center;
}

.fadingOut {
    opacity: 0;
}

.errored {
    pointer-events: auto;
    transition: none;
    opacity: 1;
}

.errorContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacer-24);
    padding: var(--spacer-80);
    text-align: center;
}

.heading {
    font: var(--font-h-48);
}

.errorMessage {
    font: var(--font-p-18);
    margin: 0;
    max-width: 650px;

    a {
        color: inherit;
        font: var(--font-text-link-14);
        font-size: inherit;
        text-decoration: underline;
    }
}

.logo {
    position: absolute;
    top: 45%;
    left: 50%;
    translate: -50% -50%;
    width: 120px;
    fill: var(--white);
    animation: pulse 2500ms ease-in-out infinite;
}

@keyframes pulse {
    0%,
    100% {
        opacity: 0.2;
    }

    50% {
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .logo {
        animation: none;
        opacity: 0.85;
    }
}
